import { TuitionFeeGroup } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    tuitionFeeGroups: [],
    typeGroup: null,
    groupSearchParams: {},
    totalItems: 0,
    itemsPerPage: 10,
    pageText: '',
    loading: false,
    group: {},
    totalStudent: 0
  },
  actions: {
    async fetchOne({ state, commit }, groupId) {
      const group = await TuitionFeeGroup.fetchOne(groupId)
      commit('changeState', { typeGroup: group.typeGroup })
      commit('changeState', { group })
    },
    async fetchAll({ state }, param) {
      const groups = await TuitionFeeGroup.fetch(param)
      return groups
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, type }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.groupSearchParams) {
        const groupSearchParams = {
          ...state.groupSearchParams,
          type
        }
        const [totalItems, tuitionFeeGroups] = await Promise.all([
          TuitionFeeGroup.count(groupSearchParams),
          TuitionFeeGroup.fetchTuitionFeeGroup({
            ...groupSearchParams,
            _start: (page - 1) * itemsPerPage,
            _limit: itemsPerPage,
            _sort: 'title:ASC'
          })
        ])
        // let list = await getListGroup(tuitionFeeGroups)
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            tuitionFeeGroups,
            totalItems,
            itemsPerPage,
            groupSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async createGroup({ dispatch, commit }, data) {
      const tuitionFee = await TuitionFeeGroup.create(data)
      dispatch('searchGroup', { type: data.type, category: tuitionFee.category, id: tuitionFee.id })
      commit('changeState', { group: tuitionFee })
    },
    async fetchGroups(_, params) {
      const res = await TuitionFeeGroup.fetchTuitionFeeGroup(params)
      return res
    },
    async searchGroup({ commit, state, dispatch }, query) {
      const groupSearchParams = {
        ...query,
        _limit: state.itemsPerPage,
        category: query.category,
        tags_contains: query.tags_contains
      }
      commit('changeState', { groupSearchParams })
      dispatch('requestPageSettings', { type: query.type })
    },
    async updateGroup({ commit }, data) {
      const res = await TuitionFeeGroup.update(data.id, { title: data.title })
      commit('changeState', { group: res })
      return res
    },
    async deleteGroup({ commit }, id) {
      const res = await TuitionFeeGroup.remove(id)
      commit('removeInDisplay', id)
      return res
    },
    clean({ commit }) {
      commit('clean')
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    clean(state) {
      state.tuitionFeeGroups = []
      state.groupSearchParams = {}
      state.totalItems = 0
      state.itemsPerPage = 5
    },
    removeInDisplay(state, id) {
      state.tuitionFeeGroups = state.tuitionFeeGroups.filter(item => item.id !== id)
    },
    setTypeGroup(state, typeGroup) {
      state.typeGroup = typeGroup
    }
  },
  getters: {
    groupInfo(state) {
      return state.group
    },
    typeGroup(state) {
      return state.typeGroup
    }
  }
}
